import { createSplitPanelLoader } from "@amzn/awsui-app-layout-loader";
import { createWidgetizedSplitPanel, SplitPanelImplementation } from "./implementation";

export const SplitPanelInternal = createWidgetizedSplitPanel(
  createSplitPanelLoader({ Fallback: SplitPanelImplementation }),
);
